import BaseBean from "@/utils/BaseBean";

export interface IPersonCardDataObj {
    utilInst:PersonCardUtil
    formRef:any
    disabled:boolean
    corpTreeData: Array<any>
    deptTreeData:Array<any>
    compParams: any
    form: any
    rules: TFormRule
    otherParams:any
}
export default class PersonCardUtil extends BaseBean{
    public dataObj:IPersonCardDataObj

    constructor(proxy:any,dataObj:IPersonCardDataObj) {
        super(proxy);
        this.dataObj=dataObj
    }
    public async requestDeptData(corpId:string):Promise<void>{
        this.dataObj.deptTreeData = await this.utils.Api.deptTreeData({
            corpId: corpId
        });
    }
    public async corpChange(selItem:string,utilInst:PersonCardUtil):Promise<any>{
        await utilInst.dataObj.utilInst.requestDeptData(selItem);
    }
    //改变状态
    public changeStatus(params:any):void{
        this.utils.Tools.configBox({
            message:'确定要执行该操作吗?',
            sureFn:async ()=> {
                let url = this.dataObj.compParams.modelPath + "/custom";
                let res = await this.utils.Api.postRequest({ url: url, params: params});
                if(res.result){
                    this.utils.Tools.success({ message: res.msg });
                    if (this.proxy.engine.engineParams.ownerComp && this.proxy.engine.engineParams.ownerComp.queryHandler) this.proxy.engine.engineParams.ownerComp.queryHandler();
                    await this.proxy.engine.engineUtil.doAddOrLoad(this.proxy.engine.id);
                }
            }
        });
    }
}